import { OrganType } from '@nkr/enums/organ-type';
import { IDashDonorData } from '@nkr/models/index';
import { Utility } from '@nkr/services/utility';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { Table } from 'react-bootstrap';

interface IProps {
    data: IDashDonorData,
    formattedStartDate: string,
    formattedEndDate: string,
}

const DonorType = (props: IProps) => {
    const { app: { site } } = useAppHookContext();
    const { data: donorData, formattedStartDate, formattedEndDate } = props;

    return (
        <Table bordered striped>
            <thead>
                <tr>
                    <th colSpan={3} style={{ background: '#337ab7', color: 'white' }}><span style={{ float: 'left' }}>Donor Type </span> <span style={{ float: 'right' }}>({formattedStartDate} - {formattedEndDate})</span></th>
                </tr>
                <tr>
                    <th style={{ backgroundColor: '#f0f0f0' }}>Type</th>
                    <th style={{ textAlign: 'center', backgroundColor: '#f0f0f0' }}>Total</th>
                    <th style={{ textAlign: 'center', backgroundColor: '#f0f0f0' }}>Percent</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Total: </td>
                    <td style={{ textAlign: 'center' }}>{donorData.startedCount}</td>
                    <td style={{ textAlign: 'center' }}>--</td>
                </tr>
                <tr>
                    <td>Non-Directed Donors: *</td>
                    <td style={{ textAlign: 'center' }}>{donorData.nddCount} </td>
                    <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.nddCount, donorData.startedCount)} </td>
                </tr>
                <tr>
                    <td>Directed Donors: *</td>
                    <td style={{ textAlign: 'center' }}>{donorData.ddCount} </td>
                    <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.ddCount, donorData.startedCount)} </td>
                </tr>
                {site.organType == OrganType.Kidney && (
                    <>
                        <tr>
                            <td>Voucher Donors: *</td>
                            <td style={{ textAlign: 'center' }}>{donorData.adpCount} </td>
                            <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.adpCount, donorData.startedCount)} </td>
                        </tr>
                        <tr>
                            <td>Standard Voucher Count: *</td>
                            <td style={{ textAlign: 'center' }}>{donorData.standardVoucherCount} </td>
                            <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.standardVoucherCount, donorData.startedCount)} </td>
                        </tr>
                        <tr>
                            <td>Family Voucher Count: *</td>
                            <td style={{ textAlign: 'center' }}>{donorData.familyVoucherCount} </td>
                            <td style={{ textAlign: 'center' }}>{Utility.percent(donorData.familyVoucherCount, donorData.startedCount)} </td>
                        </tr>
                    </>
                )}
            </tbody>
        </Table>
    );
}

export default DonorType;